

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Backup-styles/Backup.css';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import Paginador from '../../generales/Paginador';
import LoadSimple from '../../LoadSimple';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
const Backup = ({handleShowPopup,handleChangEdit, events,languaje,mode,server}) => {
    const [storageInfo, setStorageInfo] = useState({ total_space: 0, used_space: 0, used_percent: 0 });
    const [backupConfig, setBackupConfig] = useState({ frequency: 'daily', status: 'active', day_of_week: '', backup_time: '' });
    const [backupHistory, setBackupHistory] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [requestType, setRequestType] = useState('');
    const [requestMessage, setRequestMessage] = useState('');
    const [limitList, setLimitList] = useState(50);
    const [pageActual, setPageActual] = useState(1);
    const [searchResults, setSearchResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading,setLoading]=useState(false)
    var dataList = searchTerm === "" ? backupHistory: searchResults;

    // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
    const startLimit = limitList * pageActual - limitList;
    const pages = parseInt(dataList.length / limitList) + 1;

    // Fetch storage info
    const fetchStorageInfo = async () => {
        try {
            const response = await axios.get(server.url+'/api/v1/cassia/backup/backup/storageDataGB');
            setStorageInfo(response.data.data);
        } catch (error) {
            console.error('Error fetching storage info:', error);
        }
    };

    // Fetch backup config
    const [loadConfig,setLoadConfig]=useState(false)
    const fetchBackupConfig = async () => {
        setLoadConfig(true)
        try {
            const response = await axios.get(server.url+'/api/v1/cassia/backup/config');
            const data = response.data.data;
            // Formatear `backup_time` a `HH:MM` para el input de tipo `time`
            const formattedTime = data.backup_time.slice(0, 5); // Ejemplo: "02:00:00" -> "02:00"
            setBackupConfig({ ...data, backup_time: formattedTime });
            setLoadConfig(false)
        } catch (error) {
            console.error('Error fetching backup config:', error);
        }
    };

    // Fetch backup history
    const fetchBackupHistory = async () => {
        try {
            const response = await axios.get(server.url+'/api/v1/cassia/backup/history');
            setBackupHistory(response.data.data);
        } catch (error) {
            console.error('Error fetching backup history:', error);
        }
    };

    useEffect(() => {
        fetchStorageInfo();
        fetchBackupConfig();
        fetchBackupHistory();
    }, []);

    // Update backup config
    const updateBackupConfig = async () => {
        try {
            await axios.put(server.url+'/api/v1/cassia/backup/config', backupConfig);
            // alert('Configuración de copia de seguridad actualizada');
            handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['configRespaldoComplete'])),'', true)
            fetchBackupConfig();
        } catch (error) {
            console.error('Error updating backup config:', error);
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['configRespaldoError']), false)
            // alert('Error al actualizar la configuración');
        }
    };

    // Handle open/close modal
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
        setIsModalOpen(false);
        setRequestType('');
        setRequestMessage('');
    };

    // Send request
    const handleRequestSubmit = async () => {
        Registrar()
        // alert(`Solicitud de "${requestType}" enviada con el mensaje: ${requestMessage}`);
        // closeModal();
    };
    const Registrar=()=>{
       
        let method='POST'
        let url_add=''
        let data={
            type: requestType,
                message: requestMessage
          }
       
        
        
        
        setLoading(true)
          const fetchDataPost = async () => {
            
         try {
            // console.log(method,server.url+'/api/v1/cassia/exceptions'+url_add)
          
            // console.log(localStorage.getItem('access_token'))
              const response = await fetch(server.url+'/api/v1/cassia/backup/backup_user_request', {
                method: method,  
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                body: JSON.stringify(data),
              });
            //  console.log(response)
              if (response.ok) {
                setLoading(false)
                // const data1 = await response.json();
                handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['configRespaldoComplete'])),'', true)
                closeModal();
              
            
              } else {
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
                handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['configRespaldoError']), false)
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
    const handleSelectChange = (e) => {
        setLimitList(e.target.value);setPageActual(1);
      };

    const totalSpace = parseFloat(storageInfo.total_space) || 0;
    const usedSpace = parseFloat(storageInfo.used_space) || 0;
    const freeSpace = totalSpace > usedSpace ? (totalSpace - usedSpace) : 0;
    const usedPercent = totalSpace > 0 ? ((usedSpace / totalSpace) * 100).toFixed(1) : 0;

    const dataPie = [
      { name: capitalizeFirstLetter(lang[languaje]['espacioUtilizado']), value: usedSpace },
      { name: 'Espacio Libre', value: freeSpace }
    ];
    // Color variables dynamically adapt to light/dark themes
    const COLORS = ['var(--second-color)', 'var(--border-table-color)'];

    return (
        <div className="backup-container">
            {/* Storage Information Cards */}
            <div className="cards-container" style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
                {/* Visual Gauge inside main card */}
                <div className="cardBackUp" style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h3 style={{color:'var(--txt-color)'}}>{capitalizeFirstLetter(lang[languaje]['espacioUtilizado'])}</h3>
                    <div style={{ width: '100%', minWidth: 0, height: '220px', position: 'relative' }}>
                        <ResponsiveContainer width="99%" height="100%">
                            <PieChart>
                              <Pie
                                data={dataPie}
                                cx="50%"
                                cy="75%"
                                startAngle={180}
                                endAngle={0}
                                innerRadius={80}
                                outerRadius={110}
                                paddingAngle={0}
                                dataKey="value"
                                stroke="none"
                              >
                                {dataPie.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                              </Pie>
                              <Tooltip 
                                formatter={(value) => `${value.toFixed(2)} GB`} 
                                contentStyle={{ borderRadius: '8px', border: '1px solid var(--border-table-color)', backgroundColor: 'var(--white-color)' }}
                              />
                            </PieChart>
                        </ResponsiveContainer>
                        <div style={{ position: 'absolute', bottom: '30px', left: '0', right: '0', textAlign: 'center', fontSize: '32px', fontWeight: 'bold', color: 'var(--txt-color)' }}>
                            {usedPercent}%
                        </div>
                    </div>
                </div>

                {/* Vertical Stat Cards */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div className="cardBackUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 0, padding: '20px' }}>
                        <h3 style={{color:'var(--txt-color)', margin: 0}}>{capitalizeFirstLetter(lang[languaje]['espacioTotal'])}</h3>
                        <p style={{color:'var(--txt-color)', margin: 0, fontSize: '24px'}}>{totalSpace.toFixed(2)} GB</p>
                    </div>
                    <div className="cardBackUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 0, padding: '20px' }}>
                        <h3 style={{color:'var(--txt-color)', margin: 0}}>{capitalizeFirstLetter(lang[languaje]['espacioUtilizado'])}</h3>
                        <p style={{color:'var(--second-color)', margin: 0, fontSize: '24px'}}>{usedSpace.toFixed(2)} GB</p>
                    </div>
                    <div className="cardBackUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 0, padding: '20px' }}>
                        <h3 style={{color:'var(--txt-color)', margin: 0}}>Espacio Libre</h3>
                        <p style={{color:'#4CC790', margin: 0, fontSize: '24px'}}>{freeSpace.toFixed(2)} GB</p>
                    </div>
                </div>
            </div>

            {/* Backup Configuration */}
            <div className="backup-config">
                <h2 style={{color:'var(--third-color)'}}>{capitalizeFirstLetter(lang[languaje]['configRespaldo'])}</h2>
                <div className="config-field">
                    <label style={{color:'var(--txt-color)'}}>{capitalizeFirstLetter(lang[languaje]['frecuencia'])}</label>
                    <select value={backupConfig.frequency} onChange={(e) => setBackupConfig({ ...backupConfig, frequency: e.target.value, day_of_week: (e.target.value=='daily')?null:'Monday' }) }>
                        {
                            
                            (loadConfig)? <option value="">{'----'}</option>:
                            <>
                             <option value="daily">{capitalizeFirstLetter(lang[languaje]['diario'])}</option>
                             <option value="weekly">{capitalizeFirstLetter(lang[languaje]['semanal'])}</option>
                            </>
                        }
                       
                    </select>
                </div>
                <div className="config-field">
                    <label style={{color:'var(--txt-color)'}}>Status</label>
                    <select value={backupConfig.status} onChange={(e) => setBackupConfig({ ...backupConfig, status: e.target.value })}>
                    {
                        (loadConfig)? <option value="">{'----'}</option>:
                            <>
                                <option value="active">{capitalizeFirstLetter(lang[languaje]['activo'])}</option>
                                <option value="inactive">{capitalizeFirstLetter(lang[languaje]['inactivo'])}</option>
                            </>
                    }
                        </select>
                </div>
                {backupConfig.frequency === 'weekly' && (
                    <div className="config-field">
                        <label style={{color:'var(--txt-color)'}}>{capitalizeFirstLetter(lang[languaje]['diaSemana'])}</label>
                        <select value={backupConfig.day_of_week} onChange={(e) => setBackupConfig({ ...backupConfig, day_of_week: e.target.value })}>
                            <option value="Monday">{capitalizeFirstLetter(lang[languaje]['lunes'])}</option>
                            <option value="Tuesday">{capitalizeFirstLetter(lang[languaje]['martes'])}</option>
                            <option value="Wednesday">{capitalizeFirstLetter(lang[languaje]['miercoles'])}</option>
                            <option value="Thursday">{capitalizeFirstLetter(lang[languaje]['jueves'])}</option>
                            <option value="Friday">{capitalizeFirstLetter(lang[languaje]['viernes'])}</option>
                            <option value="Saturday">{capitalizeFirstLetter(lang[languaje]['sabado'])}</option>
                            <option value="Sunday">{capitalizeFirstLetter(lang[languaje]['domingo'])}</option>
                        </select>
                    </div>
                )}
                <div className="config-field">
                    <label style={{color:'var(--txt-color)'}}>{capitalizeFirstLetter(lang[languaje]['hora'])}</label>
                    <input
                        type="time"
                        value={backupConfig.backup_time}
                        onChange={(e) => setBackupConfig({ ...backupConfig, backup_time: e.target.value })}
                    />
                </div>
                {/* {
                    (loadConfig)?<LoadSimple></LoadSimple>:
                    <button className="update-config-button" onClick={updateBackupConfig} >{capitalizeFirstLetter(lang[languaje]['actualizar'])}</button>
                } */}
               
            </div>

            {/* Backup History */}
            <div className="backup-history">
                <h2 style={{color:'var(--third-color)'}}>{capitalizeFirstLetter(lang[languaje]['backHistory'])}</h2>
                {/* <table className="history-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Backup Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {backupHistory.map((history) => (
                            <tr key={history.id}>
                                <td>{history.id}</td>
                                <td>{new Date(history.backup_date).toLocaleString()}</td>
                                <td>{history.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table> */}
               <div className={"content-portafolio"+mode}>
       
        
       <div className="cont-portafolio-table">
         <div className="content-card-portafolio" id="content">
           
              
         <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        <div className="field-head-table-mantenimiento field-larger">  ID</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'70%'}}>{capitalizeFirstLetter(lang[languaje]['fechaRespaldo'])} </div>
        <div className="field-head-table-mantenimiento field-larger" >{'Status'}</div>
        </div>
      </div>
      <div className="body-table-portafolio" style={{height:'120px'}}>
       
       {
        dataList
        .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
        .map((elemento, indice) => (
          <div
            className={"row-table-portafolio"+mode}
            key={indice}
          >
             
            <div className="field-body-table-mantenimiento field-larger">
              {elemento.id}
            </div>
            <div className="field-body-table-mantenimiento field-larger" style={{width:'70%'}}>
              {elemento.backup_date.slice(-10)+" "+elemento.backup_date.slice(0,8)}
            </div>
            <div className="field-body-table-mantenimiento field-larger" >
              {elemento.status}
            </div>
            
            
           
            
            
           
          </div>
        ))
       }
      </div>
    </div>
           
         </div>
       </div>
       <div className={"content-portafolio-footer-min"+mode} style={{height: '30px !important'}}>
                 <div className="cont-display-paginador">
                 <Paginador  pages={pages}
                             pageActual={pageActual}
                             setPageActual={setPageActual}
                             mode={mode}></Paginador>
                 </div>
                 <div className="cont-display-paginador">
                   <div className={"cont-half-display-paginador"+mode}>
                   
               <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
                   </div>
                   <div className={"cont-half-display-paginador"+mode}>
                   <p style={{  textAlign: "center" }}>
                         &nbsp;
                         {"(" +
                     (startLimit + 1) +
                     " - " +
                     (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                       ?  parseInt(pageActual ) * parseInt(limitList)
                       : dataList.length) +
                     ")  "+lang[languaje]['de']+" " +
                     dataList.length +
                     " "+lang[languaje]['resultados']}
                   </p>
                 </div>
                 </div>
     
               </div>
       </div>
            </div>

            {/* Request Modal */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2 style={{color:'var(--third-color)'}}>{capitalizeFirstLetter(lang[languaje]['enviarPetcion'])}</h2>
                        <p>{capitalizeFirstLetter(lang[languaje]['msgSendRequest'])}</p>
                        <div className="form-group">
                            <label style={{color:'var(--third-color)'}}>{capitalizeFirstLetter(lang[languaje]['tipoPeticion'])}</label>
                            <select value={requestType} onChange={(e) => setRequestType(e.target.value)}>
                                <option value="">{capitalizeFirstLetter(lang[languaje]['seleccionarOpcion'])}</option>
                                <option value="recovery">{capitalizeFirstLetter(lang[languaje]['dataRecovery'])}</option>
                                <option value="destruction">{capitalizeFirstLetter(lang[languaje]['dataDestruction'])}</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label style={{color:'var(--third-color)'}}>{capitalizeFirstLetter(lang[languaje]['mensaje'])}</label>
                            <textarea value={requestMessage} onChange={(e) => setRequestMessage(e.target.value)} placeholder="Escriba su mensaje aquí..." />
                        </div>
                        <div className="modal-buttons">
                            {(loading)?<LoadSimple></LoadSimple>
                            :
                            <>
                             <button onClick={closeModal}>{capitalizeFirstLetter(lang[languaje]['cancelar'])}</button>
                            <button onClick={handleRequestSubmit}>{capitalizeFirstLetter(lang[languaje]['enviarPetcion'])}</button>
                            
                            </>
                       }
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Backup;
